module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--terms"
  }, [_c(_vm.content, {
    tag: "component",
    staticClass: "group group--first-last typeset typeset--terms links"
  }), _vm._v(" "), _c('ui-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61559961"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Terms.vue
// module id = 264
// module chunks = 0